/**
 * Wraps a URL as a CSS `url("…")` value, escaping what could break out of it.
 *
 * These posters are signed per entry, so the URL cannot live in a stylesheet and has
 * to travel as a custom property — which means string interpolation into CSS, and
 * that is only safe if the quote that closes the value cannot appear inside it. A
 * `"` would end the value early and leave the rest of the URL parsed as declarations.
 *
 * Today's inputs are admin-curated CloudFront and S3 URLs, so this is a guard rather
 * than a fix for something observed. It is cheap, and the alternative is remembering
 * the rule at every call site: `%22` for the quote, plus the two characters that
 * would let a value escape its declaration entirely.
 */
export function cssUrl(url: string): string {
  /* Explicit percent-escapes, not `encodeURIComponent`. That function leaves `(`
     and `)` alone -- they are unreserved in a URI -- so it cannot be used to make a
     string safe for a CSS `url()`, where `)` is exactly the character that closes
     the function early. Spelling the three out is what actually holds. */
  const safe = url
    .replace(/"/g, '%22')
    .replace(/[\n\r]/g, '')
    .replace(/\(/g, '%28')
    .replace(/\)/g, '%29')
    .replace(/;/g, '%3B');
  return `url("${safe}")`;
}
